import React from 'react';
import { Box } from '@mui/material';
import Text from 'global/components/text';

const headerValueSx = { pl: 0.2 };

const headerItemSx = {
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};

const headerItemHideBelowLgSx = {
  ...headerItemSx,
  display: { xs: 'none', lg: 'flex' },
};

export default function HeaderItem(props) {
  const { label, value, content, capitalize, showInMobile = true } = props;
  let val = value;

  if (capitalize && typeof val === 'string' && val) {
    val = val.charAt(0).toUpperCase() + val.slice(1);
  }

  const hasContent = content !== undefined;

  return (
    <Box sx={showInMobile ? headerItemSx : headerItemHideBelowLgSx}>
      {label ? <Text type="label_small">{label}</Text> : null}
      {hasContent ? (
        <Box sx={{ ...headerValueSx, minWidth: 0, maxWidth: '100%' }}>{content}</Box>
      ) : (
        <Text sx={{ ...headerValueSx, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{val}</Text>
      )}
    </Box>
  );
}
